module.exports = __webpack_public_path__ + "img/royal-landing-banner.be0c58df.png";